// src/App.jsx
import React from "react";
import Navbar from "./sections/Navbar";
import Hero from "./sections/Hero";
import Services from "./sections/Services";
import ReactLenis from "lenis/react";
import About from "./sections/About";
import Works from "./sections/Works";
import Contact from "./sections/Contact";
import Achievements from "./sections/Achievements";
import { RotatingPopup } from "./components/RotatingPopup";

const App = () => {
  return (
    <ReactLenis root className="relative w-screen min-h-screen overflow-x-auto">
      <Navbar />
      <Hero />
      <Services />
      <About />
      <Achievements />
      <Works />
      <Contact />
      <RotatingPopup />
    </ReactLenis>
  );
};

export default App;
